import './ProgressBar.css';

function ProgressBar({percentage})
{
 const getColor = () =>
 {
    if(percentage < 14) return '#0a0a0f';
     if(percentage < 28) return '#1a1a2e';
      if(percentage < 42) return '#2d2d4a';
      if(percentage < 56) return '#4a4a6a';
      if(percentage < 70) return '#4a6a8a';
    else if(percentage < 84) return  '#3a7aaa';
    else return '#2a8acc' ;
  }
  return(
    <div className='progress-bar'>
 <div 
 className='progress-bar-fill'
 style={{width:`${percentage}%`, background:getColor()}}>

 </div>
    </div>
  )
}
export default ProgressBar;